import { render } from "./Sections.vue?vue&type=template&id=67f5108f&ts=true"
import script from "./Sections.vue?vue&type=script&lang=ts"
export * from "./Sections.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__